import { ButtonDesignTokens } from '@primeuix/themes/types/button';

export const ezButtonThemeConfig: ButtonDesignTokens = {
  colorScheme: {
    light: {
      outlined: {
        primary: {
          borderColor: '#002F36',
          color: '#002F36',
          hoverBackground: '#002F3610',
        },
        danger: {
          borderColor: '#D64545',
          hoverBackground: '#D6454510',
          color: '#D64545',
        },
        secondary: {
          borderColor: '#4C5A5E',
          hoverBackground: '#4C5A5E10',
          color: '#4C5A5E',
        },
      },
      text: {
        primary: {
          hoverBackground: '#00292f10',
          color: '#002F36',
        },
      },
      root: {
        primary: {
          background: '#002F36',
          borderColor: '#002F36',
          hoverBackground: '#00292F',
          hoverBorderColor: '#00292F',
          activeBackground: '#002329',
          activeBorderColor: '#002329',
          color: 'white',
        },
        danger: {
          background: '#D64545',
          borderColor: '#D64545',
          hoverBackground: '#B73737',
          hoverBorderColor: '#B73737',
          activeBackground: '#8E1E2B',
          activeBorderColor: '#8E1E2B',
          color: 'white',
        },
        secondary: {
          background: '#4C5A5E',
          borderColor: '#4C5A5E',
          hoverBackground: '#5C6F74',
          hoverBorderColor: '#5C6F74',
          activeBackground: '#3D484B',
          activeBorderColor: '#3D484B',
          color: 'white',
          hoverColor: 'white',
        },
        info: {
          background: '#2D89FF',
          borderColor: '#2D89FF',
          hoverBackground: '#185CB0',
          hoverBorderColor: '#185CB0',
          activeBackground: '#2075DB',
          activeBorderColor: '#2075DB',
          color: 'white',
        },
        success: {
          background: '#167007',
          borderColor: '#167007',
          hoverBackground: '#1C8409',
          hoverBorderColor: '#1C8409',
          activeBackground: '#115A06',
          activeBorderColor: '#115A06',
          color: 'white',
        },
      },
    },
  },
};
